import { LAB_REPORT } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { ILabReportStatsListResponse, ILabReportStatsParamsBody } from "@/api_framework/api_modals/LabReport";
import { setStatsList } from "@/app_redux/reducers/slices/auth/lab_report_slice";

AxiosCurlirize(axios, () => {});
export const useLabReportStatsListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(
    async (filterParams: ILabReportStatsParamsBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .post(LAB_REPORT?.LAB_REPORT_STATS_LIST?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ILabReportStatsListResponse>) => {
            if (res.data.status === true) {
              dispatch(setStatsList({ data: res.data.data }));
            } else {
              dispatch(setStatsList({ data: null }));
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            // captureError(e);
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
